
import Put from './put';

export default {
	updateColor: Put.color
}
